import styled, { keyframes } from 'styled-components';
import { textStyles, theme } from '@frameio/vapor';
import { bounceLikeEasing } from '../EmojiReactions/animations';

export const borderThickness = 3;

export const StyledDiv = styled.div`
  /* Allow users to scroll the editor while the cursor is over the Grapheme Counter */
  pointer-events: none;
  position: absolute;
  right: -${borderThickness}px;
  top: 8px;
`;

const animateLimitOnKey = ({ $bgColor, $previousBgColor }) => keyframes`
  from {
    background-color: ${$previousBgColor};
    transform: scale(1.3);
  }

  to {
    background-color: ${$bgColor};
    transform: scale(1.0);
  }
`;

export const StyledCircle = styled.div<{
  $bgColor: string;
  $previousBgColor: string;
}>`
  ${textStyles.secondary};
  align-items: center;
  animation: ${(p) => animateLimitOnKey(p)} 0.3s;
  animation-timing-function: ${bounceLikeEasing};
  background-color: ${(p) => p.$bgColor};
  border: ${borderThickness}px solid ${theme.colors.components.modal.background};
  border-radius: 24px;
  color: ${theme.colors.components.chip.text};
  display: flex;
  font-variant-numeric: tabular-nums;
  height: 30px;
  justify-content: center;
  min-width: 30px;
  padding: 0 5px;
  transform-origin: center;
`;
